// ** React Imports
import { useContext } from 'react'

// ** Component Imports
import { AbilityContext } from 'src/layouts/components/acl/Can'

const CanViewNavLink = props => {
  // ** Props
  const { children, navLink } = props

  // ** Hook
  const ability = useContext(AbilityContext)

  // During migration: if no ACL meta is provided, don't block rendering.
  if (!navLink?.action || !navLink?.subject) {
    return <>{children}</>
  }

  return ability && ability.can(navLink.action, navLink.subject) ? <>{children}</> : null
}

export default CanViewNavLink
